<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { AppState } from '../../etc/stores';
  import { createEventDispatcher } from 'svelte';
  import Text from '../typography/Text.svelte';
  import TextInput from '../form/TextInput.svelte';
  import Button from '../form/Button.svelte';
  import { replaceVariables } from '../../i18n';

  const dispatch = createEventDispatcher();

  const t = (text: string, values?: Record<string, string | number>) => {
    return replaceVariables(
      $_(`postcheckout_how_it_works.form.${text}`),
      values
    );
  };

  export let email = '';
  export let error = '';
  export let loading = false;
</script>

<div class="twism-postcheckout-how--form">
  <div class="twism-postcheckout-how--form--box">
    <Text type="medium" class="twism-postcheckout-how--form--box--text"
      >{t('title')}</Text
    >
  </div>
  <TextInput
    label=""
    value={email}
    on:input={e => dispatch('changeEmail', e.detail)}
    name="customer-email"
    type="text"
    placeholder={t('input-placeholder')}
    {error}
    removeIconsTopOffset
  />
  <div class="twism-postcheckout-how--form--button">
    <Button {loading} on:click={() => dispatch('submit')}>
      <Text
        type="medium"
        bold
        color={$AppState.theme.colors.textAboveBackground}
      >
        {t('submit')}
      </Text>
    </Button>
  </div>
  <div
    class="twism-postcheckout-how--form--signin"
    on:click={() => dispatch('signin')}
  >
    <Text type="medium" color={$AppState.theme.colors.primary200}>
      {t('already_have_account')}
    </Text>
  </div>
  <div class="twism-postcheckout-how--form--terms">
    <Text type="medium" class="twism-postcheckout-how--content--terms--text">
      {@html t('terms')}
    </Text>
  </div>
</div>

<style lang="scss">
  .twism-postcheckout-how--form {
    &--button {
      margin-top: 12px;
      margin-bottom: 22px;
    }

    &--terms {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 62px;
      opacity: 0.7;
    }

    &--signin {
      width: 100%;
      display: flex;
      justify-content: center;
    }

    &--box {
      width: 100%;
      box-sizing: border-box;
      border-radius: 8px;
      background: var(--twism-theme-primary600);
      padding: 18px 16px 16px 18px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      margin-bottom: 24px;
    }
  }

  :global(.twism-postcheckout-how--form--signin p) {
    cursor: pointer;
    text-decoration: underline;
  }

  :global(.twism-postcheckout-how--content--terms--text) {
    text-align: center !important;
    @media screen and (max-width: 468px) {
      font-size: 11px;
    }
  }

  :global(.twism-postcheckout-how--form--box--text) {
    text-align: center !important;
    font-weight: 500;
  }

  :global(.twism-postcheckout-how--form .input__field) {
    border-radius: 12px !important;
    border-width: 2px !important;
    margin: 0 !important;
    height: 48px !important;
  }
</style>
